"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { MarkdownRenderer } from "@nxt-costco-com/forge-components";
import GenericImageHandler from "../../Util/GenericImageHandler.js";
import { LegendTiles } from "./LegendTiles.js";
import { VIEW_NAME_IMAGE_WITH_LEGEND } from "./constants.js";
import { ImageWithLegendContainer, InstructionText, LegendImageBody } from "./styles.js";
function ImageWithLegend({
  data
}) {
  var _a;
  if (!data) {
    return null;
  }
  const { image_with_legend } = data || {};
  const { section_title } = image_with_legend || "";
  return /* @__PURE__ */ jsxs(ImageWithLegendContainer, { "data-testid": VIEW_NAME_IMAGE_WITH_LEGEND, children: [
    section_title && /* @__PURE__ */ jsx(InstructionText, { children: /* @__PURE__ */ jsx(MarkdownRenderer, { markdown: section_title }) }),
    /* @__PURE__ */ jsxs(LegendImageBody, { children: [
      /* @__PURE__ */ jsx(LegendTiles, { data }),
      /* @__PURE__ */ jsx(
        GenericImageHandler,
        {
          sx: {
            alignItems: "flex-end",
            display: "flex",
            height: "auto",
            justifyContent: "flex-end",
            maxHeight: "100%",
            maxWidth: {
              lg: "75%",
              md: "100%",
              sm: "100%",
              xs: "100%"
            },
            width: "auto"
          },
          alt: `${image_with_legend == null ? void 0 : image_with_legend.image_alt_text}`,
          caption: image_with_legend == null ? void 0 : image_with_legend.image_caption,
          src: (_a = image_with_legend == null ? void 0 : image_with_legend.image[0]) == null ? void 0 : _a.url
        }
      )
    ] })
  ] });
}
export {
  ImageWithLegend
};
